import script from "./HelloWorld.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&setup=true&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=64c9fe70&scoped=true&lang=css"
import "./HelloWorld.vue?vue&type=style&index=1&id=64c9fe70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c9fe70"]])

export default __exports__